import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import report from "../views/ReportView.vue";
import AboutView from "../views/AboutView.vue";
const routes = [
  {
    path: "/",
    name: "report_older",
    component: report,
    meta: { title: '报告页' }
  },
  {
    path: "/report",
    name: "report",
    component: report,
    meta: { title: '报告页' }
  },
  {
    path: "/home",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: AboutView
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
